import React, { useState, useEffect } from "react"
import {
	DataTable,
	DataTableBody,
	DataTableCellAlphaNumeric,
	DataTableHead,
	DataTableRow,
	IconButton,
} from "@walmart-web/livingdesign-components"
import DataHeader from "components/Shared/InformationTable/DataHeader"
import { getObject, mapData, onFilter } from "./utils"
import * as Icon from "@walmart-web/livingdesign-icons"
import { ColumnsHeader } from "components/Shared/InformationTable/interfaces"
import {
	AdministrationOptions,
	TableColumn,
	Views,
} from "components/UserManagement/interfaces"
import Delete from "components/UserManagement/components/Delete"

interface TableProps {
	data: Array<any>
	searchValue: string
	dataId: string
	columns: Array<TableColumn>
	headers: () => Array<ColumnsHeader>
	section: AdministrationOptions
	refetch: () => Promise<any>
	setView: (value: Views) => void
	selection: any
	setSelection: (value: any) => void
}

const Table: React.FC<TableProps> = ({
	data,
	searchValue,
	columns,
	headers,
	section,
	refetch,
	setView,
	selection,
	setSelection,
	dataId,
}) => {
	const [resultData, setResultData] = useState<Array<any>>(
		mapData(data, columns)
	)
	const [isOpen, setIsOpen] = useState<boolean>(false)

	useEffect(() => {
		const mappedData = mapData(data, columns)
		setResultData(mappedData.filter((item: any) => onFilter(item, searchValue)))
	}, [searchValue])

	return (
		<React.Fragment>
			<Delete
				section={section}
				isOpen={isOpen}
				onClose={() => setIsOpen(false)}
				selection={selection}
				refetch={refetch}
			/>
			<DataTable>
				<DataTableHead>
					<DataTableRow>
						<DataHeader
							columnsHeader={headers()}
							dataTable={resultData}
							onSort={(e) => setResultData(e)}
						></DataHeader>
					</DataTableRow>
				</DataTableHead>
				<DataTableBody>
					{resultData.map((item: any) => {
						return (
							<DataTableRow key={item[dataId]}>
								{columns.map((columnItem) => (
									<React.Fragment key={item[dataId] + columnItem.column}>
										<DataTableCellAlphaNumeric>
											{columnItem.render
												? columnItem.render(item[columnItem.column])
												: item[columnItem.column]}
										</DataTableCellAlphaNumeric>
									</React.Fragment>
								))}
								<DataTableCellAlphaNumeric>
									<IconButton
										disabled={section === "organizations"}
										onClick={() => {
											setSelection(getObject(dataId, { data, item }))
											setView("Edit")
										}}
										a11yLabel="edit"
									>
										<Icon.Pencil />
									</IconButton>
									<IconButton
										onClick={() => {
											setSelection(getObject(dataId, { data, item }))
											setIsOpen(true)
										}}
										a11yLabel="delete"
									>
										<Icon.TrashCan />
									</IconButton>
								</DataTableCellAlphaNumeric>
							</DataTableRow>
						)
					})}
				</DataTableBody>
			</DataTable>
		</React.Fragment>
	)
}

export default Table
